<template>
  <common-modal-section @close="emitClose">
    <template v-slot:default>
      <modal-title-parts :title="title" />
      <div class="titled-modal-section__content">
        <slot />
      </div>
    </template>

    <template v-slot:buttons>
      <atom-input-button
        :linkText="$t('common.ok')"
        colorType="secondary"
        :isDisabled="false"
        @push="emitClose()"
      />
    </template>
  </common-modal-section>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

/**
 * 共通 タイトル+slotモーダル テンプレート
 */
export default defineComponent({
  name: 'TitledModalSection',
  components: {
    CommonModalSection,
    ModalTitleParts,
    AtomInputButton,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss" scoped>
.titled-modal-section {
  &__content {
    margin-top: 16px;
    padding: 0 8px;
  }
}
</style>
